import { notifications } from '@mantine/notifications';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { warningNotificationIcon } from '@/theme/notificationIcons';

const OFFLINE_NOTIFICATION_ID = 'network-offline';

// Reaktivni handler u queryClient.tsx pokaže "nema veze" tek kad neki API
// poziv stvarno propadne — ovo dodaje proaktivnu detekciju preko browserovih
// online/offline eventova, čim korisnik izgubi vezu, bez obzira šalje li baš
// tada ikakav zahtjev. Notifikacija se ručno sakriva čim se veza vrati.
export const NetworkStatusWatcher = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const handleOffline = () => {
      notifications.show({
        id: OFFLINE_NOTIFICATION_ID,
        color: 'orange',
        icon: warningNotificationIcon,
        title: t('errors.network.title'),
        message: t('errors.network.message'),
        autoClose: false,
        withCloseButton: true
      });
    };

    const handleOnline = () => notifications.hide(OFFLINE_NOTIFICATION_ID);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, [t]);

  return null;
};
